import styled from 'styled-components';
import { DatePicker } from 'antd';

const RangePicker = styled(DatePicker.RangePicker)`
    .ant-calendar-picker-input
    {
        border: 1px solid rgba(0, 0, 0, 0.1) !important;
        border-radius: 4px !important;
        background-color: #ffffff !important;
        height: 40px !important;
    }
`;

export default RangePicker;
